module.exports = __webpack_public_path__ + "static/img/productimg8.8128c8a8.png";